module.exports = __webpack_public_path__ + "img/camera.e46b0d5c.svg";